import { Component, OnInit, Input } from '@angular/core';
import * as pluginDataLabels from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styles: []
})
export class PiechartComponent implements OnInit {
  // Pie
  pieChartOptions: pluginDataLabels.ChartOptions = {
    responsive: true,
    legend: {
      position: 'top',
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };

  @Input() pieChartLabels: Label[] = [];
  @Input() pieChartData: number[] = [];
  pieChartType: pluginDataLabels.ChartType = 'pie';
  pieChartLegend = true;
  pieChartPlugins = [pluginDataLabels];
  pieChartColors = [
    {
      backgroundColor: ['#06d79c', '#ffb22b', '#ef5350', '#398bf7'],
    },
  ];

  constructor() { }

  ngOnInit() {
  }

}
